module.exports = __webpack_public_path__ + "img/cocio_logo_old.185d21c1.svg";